export default "__VITE_ASSET__CB$_9n_F__"